import React, { createContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useBaseData } from "../hooks/api/baseDataApiHooks";
import ServerOfflinePage from "../components/shared/ServerOfflinePage";

export const ApiDataContext = createContext();

export const ApiDataProvider = ({ children }) => {
  const [apiData, setApiData] = useState();
  const { baseDataLoading, baseData, baseDataError, refetchBaseData } = useBaseData();

  useEffect(() => {
    if (!baseDataLoading && baseData) {
      setApiData(baseData);
    }
  }, [baseData, baseDataLoading]);

  if (baseDataError && !baseDataLoading && !apiData) {
    return <ServerOfflinePage onRetry={refetchBaseData} />;
  }

  if (baseDataLoading || apiData === undefined) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ApiDataContext.Provider value={{ apiData }}>
      {children}
    </ApiDataContext.Provider>
  );
};
